"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreditCard_1 = require("./CreditCard");
exports.default = CreditCard_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/CreditCard/index.js
// module id = 148
// module chunks = 0 1